<form class="needs-validation " [formGroup]="formEquipmentLogbook">
  <div class="row container-style mb-2">
    <div class="col-lg-4 col-md-8 col-sm-5 col-8">
      <app-custom-autocomplete formControlName="unitId" [labelText]="'Variable Medición'" [list]="listUnits"
        [required]="true" (onChangeSelect)="onChangeUnit($event)"></app-custom-autocomplete>
    </div>
    <div class="col-lg-2 col-md-3 col-sm-3 col-6">
      <app-custom-input-number formControlName="maintenanceFrequency" [labelText]="'Frecuencia'"
        [required]="true"></app-custom-input-number>
    </div>
    <div class="col-lg-2 col-md-3 col-sm-3 col-6">
      <app-custom-input-decimal formControlName="tolerance" [labelText]="'Holgura'"
        [required]="true"></app-custom-input-decimal>
    </div>
    <div class="col-lg-4 col-md-3 col-sm-3 col-6 d-flex justify-content-between align-items-end">
      <app-custom-button [label]="'Actualizar'" [severity]="'primary'" [width]="'5rem'"
        (onClick)="updateEquipmentLogbook()"></app-custom-button>

      <app-custom-button [disabled]="!swMaintenanceStrategy || !swMaintenanceScheduling" class="ms-2"
        [title]="'Agregar'" [label]="'Agregar'" [icon]="'pi pi-plus'" [width]="'5.5rem'" [severity]="'success'"
        (onClick)="addMaintenanceStrategy()"></app-custom-button>
    </div>
  </div>
  <div class="row container-style">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <form novalidate [formGroup]="formMaintenanceStrategy" [hidden]="!isFormView" class="border py-1 px-2">
        <div class="row">

          <div class="col-lg-2 col-md-3 col-sm-3 col-6">
            <app-custom-input-number formControlName="interval" [labelText]="'Invervalo'"
              [required]="true"></app-custom-input-number>
          </div>

          <div class="col-lg-2 col-md-3 col-sm-3 col-6">
            <app-custom-input-number formControlName="frequency" [labelText]="'Frecuencia'"
              [required]="true"></app-custom-input-number>
          </div>

          <div class="col-lg-2 col-md-2 col-sm-3 col-6">
            <app-custom-select formControlName="maintenancePlan" [labelText]="'Plan Mtto.'"
              [list]="listMaintenancePlans" [required]="true"></app-custom-select>
          </div>

          <div class="col-lg-2 col-md-2 col-sm-2 col-12 d-flex align-items-end mt-2 gap-2">
            <app-custom-button [label]="'Guardar'" [severity]="'primary'" [width]="'5rem'"
              (onClick)="send()"></app-custom-button>
            <app-custom-button [label]="'Cancelar'" [severity]="'danger'" (onClick)="clearForm()"></app-custom-button>
          </div>
        </div>

      </form>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 mt-1">
      <app-custom-table [headers]="maintenanceStrategyHeader" [data]="maintenanceStrategyData" [actions]="tableActions"
        [showCheckbox]=" true" [checkBoxAction]="checkboxActions" [clearSelectionTrigger]="clearSelectionTrigger"
        (onRecoverData)="getAllMaintenanceStrategiesWithPagination()" (onPageChange)="onPageChange($event)"
        (onAction)="onAction($event)">
      </app-custom-table>
    </div>
  </div>
</form>